export const stripHTML = (str: string): string => {
  return str.replace(/<[^>]*>/g, "").trim();
};

export const normalizeHTML = (str: string): string =>
  str.replace(/>\s+</g, "><").replace(/\s+/g, " ").trim();

export const normalizeAndStripHTML = (str: string): string =>
  stripHTML(str)
    .replace(/\s+/g, " ")
    .replace(/^\s+|\s+$/g, "")
    .toLowerCase();

const getPrefixMatchLength = (str1: string, str2: string): number => {
  const words1 = str1.split(/\s+/);
  const words2 = str2.split(/\s+/);
  let matchLength = 0;

  for (let i = 0; i < Math.min(words1.length, words2.length); i++) {
    if (words1[i] === words2[i]) {
      matchLength++;
    } else {
      break;
    }
  }

  return matchLength;
};

export const doesDescriptionAndTitleStartWithSameText = (
  description: string,
  title: string,
): boolean => {
  const strippedTitle = normalizeAndStripHTML(title);
  const strippedDescription = normalizeAndStripHTML(description);

  const matchingLength = getPrefixMatchLength(
    strippedTitle,
    strippedDescription,
  );

  return matchingLength >= 3;
};

export const getPromoTitleFromDescription = (
  title: string,
  description: string,
): string => {
  const beforeClaimRegex = /^(.*?)<p>\s*<strong>\s*How to claim/;
  const match = description.match(beforeClaimRegex);

  const descriptionStartsWithTitle = doesDescriptionAndTitleStartWithSameText(
    description,
    title,
  );

  if (!match) {
    return title;
  }

  return descriptionStartsWithTitle && match && match[1] ? match[1] : title;
};

export const getDescriptionStartingWithClaim = (
  description: string,
  title: string,
): string => {
  const claimRegex = /<p>\s*<strong>\s*How to claim[\s\S]*<\/p>/i;
  const matchesHowToClaim = description.match(claimRegex);

  const descriptionStartsWithTitle = doesDescriptionAndTitleStartWithSameText(
    description,
    title,
  );

  const escapedTitle = normalizeHTML(title)
    .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    .replace(/\s+/g, "\\s*");

  const removeTitleFromDescription = new RegExp(
    `<p>\\s*<strong>\\s*${escapedTitle}[.,!?\\s]*</strong>\\s*</p>|<strong>\\s*${escapedTitle}[.,!?\\s]*</strong>|<p>\\s*${escapedTitle}[.,!?\\s]*</p>|${escapedTitle}[.,!?\\s]*`,
    "gi",
  );

  if (descriptionStartsWithTitle && matchesHowToClaim && matchesHowToClaim[0]) {
    return matchesHowToClaim[0];
  }

  return normalizeHTML(description)
    .replace(removeTitleFromDescription, "")
    .trim();
};
